/** Max characters for flow-level AI help knowledge base (keep in sync with server). */
export const AI_HELP_KB_MAX_LENGTH = 4000;

export function parseAiHelpFlag(value) {
  return value === true || value === 1 || value === "true" || value === "1";
}

/**
 * Build flow_settings payload for API save.
 */
export function buildFlowSettingsPayload({ allowAiHelpDuringConversation, aiHelpKnowledgeBase }) {
  return {
    allowAiHelpDuringConversation: !!allowAiHelpDuringConversation,
    aiHelpKnowledgeBase: String(aiHelpKnowledgeBase || ""),
  };
}

/**
 * Read AI help from flow_settings (preferred) or trigger node config (legacy).
 */
export function extractFlowAiHelpFromFlow(flow, nodes = []) {
  const settings = flow?.flow_settings || {};
  const trigger = nodes.find((n) => n.type === "trigger" || n.node_type === "trigger");
  const triggerCfg = trigger?.data || trigger?.config || {};

  const enabled = parseAiHelpFlag(
    settings.allowAiHelpDuringConversation ?? triggerCfg.allowAiHelpDuringConversation
  );
  const kb = String(
    settings.aiHelpKnowledgeBase ?? triggerCfg.aiHelpKnowledgeBase ?? ""
  );

  return {
    allowAiHelpDuringConversation: enabled,
    aiHelpKnowledgeBase: kb,
  };
}

/**
 * Apply flow-level AI help settings onto the trigger node (runtime mirror for wabaserver).
 */
export function applyFlowAiHelpToNodes(nodes, settings) {
  const { allowAiHelpDuringConversation, aiHelpKnowledgeBase } = settings;
  return nodes.map((n) => {
    if (n.type !== "trigger") return n;
    return {
      ...n,
      data: {
        ...n.data,
        allowAiHelpDuringConversation: !!allowAiHelpDuringConversation,
        aiHelpKnowledgeBase: String(aiHelpKnowledgeBase || ""),
      },
    };
  });
}

/**
 * @deprecated use extractFlowAiHelpFromFlow
 */
export function extractFlowAiHelpFromNodes(nodes) {
  const trigger = nodes.find((n) => n.type === "trigger");
  if (!trigger?.data) {
    return { allowAiHelpDuringConversation: false, aiHelpKnowledgeBase: "" };
  }
  return {
    allowAiHelpDuringConversation: parseAiHelpFlag(trigger.data.allowAiHelpDuringConversation),
    aiHelpKnowledgeBase: trigger.data.aiHelpKnowledgeBase || "",
  };
}

export function validateFlowAiHelpSettings({ allowAiHelpDuringConversation, aiHelpKnowledgeBase }) {
  if (allowAiHelpDuringConversation) {
    const kb = (aiHelpKnowledgeBase || "").trim();
    if (!kb) return "Knowledge base context is required when AI help is enabled.";
    if (kb.length > AI_HELP_KB_MAX_LENGTH) {
      return `Knowledge base exceeds ${AI_HELP_KB_MAX_LENGTH.toLocaleString()} characters.`;
    }
  } else if ((aiHelpKnowledgeBase || "").length > AI_HELP_KB_MAX_LENGTH) {
    return `Knowledge base exceeds ${AI_HELP_KB_MAX_LENGTH.toLocaleString()} characters.`;
  }
  return null;
}
